module.exports = __webpack_public_path__ + "img/shotgun.double.4c15e244.png";